// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3EQ_x","description":"PatientConsentPreview_description__1n_b3"};